import { Box, IconButton, ListItemButton, ListItemIcon, ListItemText } from "@mui/material"
import { ListItemBox } from "lib/@components/ListItemBox"
import Iconify from "minimals-template/components/Iconify"
import { BlockClicks } from "lib/@components/block-clicks"
import { confirm } from "lib/@dialogs/confirm"
import { deleteRegisterAccess } from "routes/client-admin/plugins/asset-register-access/controller/deleteRegisterAccess"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import { errorSnackbar } from "lib/snackbar/error-snackbar"

export function RegisterAccessItem({ item }) {
    const { authorisedDomain } = item

    return (
        <ListItemButton className="access-item" data-cy={`accessItem${authorisedDomain}`}>
            <ListItemBox data-cy="register-access-row">
                <ListItemIcon>
                    <Iconify sx={{ width: 24, height: 24 }} icon="ic:round-token" />
                </ListItemIcon>
                <ListItemText primary={authorisedDomain} />
                <Box flex={1} />
                <BlockClicks>
                    <IconButton
                        aria-label="Remove domain access"
                        data-cy="delete-access-button"
                        color="secondary"
                        onClick={remove}
                    >
                        <Iconify icon="mdi:delete" />
                    </IconButton>
                </BlockClicks>
            </ListItemBox>
        </ListItemButton>
    )

    async function remove() {
        try {
            if (await confirm("Are you sure you want to remove this domain?", "Remove Domain Access")) {
                await deleteRegisterAccess(authorisedDomain)
                successSnackbar("Removed domain access")
            }
        } catch (e) {
            errorSnackbar("Failed to remove domain access")
        }
    }
}
